<div
  [ngStyle]="contentStyle"
  [ngClass]="[!isUsingHtmlStructure ? 'position-absolute-fill' : '']"
>
  <div
    [ngStyle]="colorTextAlignStyle"
    [ngClass]="selectedTextStyleClass"
    class="d-contents w-100"
    (click)="onActionClick()"
    [innerHTML]="renderedContentWithTimer | safeHtml"
  ></div>
</div>
